module.exports = __webpack_public_path__ + "static/media/crewstudio_app_custom_camera_h.f76d5ac8.jpg";